import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'
import LoginView from '../views/LoginView.vue'

Vue.use(VueRouter)

const home = {
    name: 'home',
    path: '/',
    component: () => import('../views/HomeView.vue'),
    meta: {
        requiresAuth: true,
        section: 'none'
    }
}

const login = {
    name: 'login',
    path: '/anmelden',
    component: LoginView,
    meta: {
        requiresAuth: false,
        section: 'none'
    }
}

const newPassword = {
    name: 'newPassword',
    path: '/neues-passwort-setzen',
    component: () => import('@/views/NewPasswordView'),
    meta: {
        requiresAuth: false,
        section: 'none'
    }
}

const bet = {
    name: 'bet',
    path: '/tippschein/:betPeriodNumber?',
    props: true,
    component: () => import('../views/BetView.vue'),
    meta: {
        requiresAuth: true,
        section: 'bet'
    }
}

const specialBet = {
    name: 'specialBets',
    path: '/sondertipps',
    component: () => import('../views/SpecialBetView.vue'),
    meta: {
        requiresAuth: true,
        section: 'bet'
    }
}

const betPeriodResults = {
    name: 'betPeriodResults',
    path: '/tipprunde/:betPeriodNumber?',
    props: true,
    component: () => import('../views/BetPeriodResultsView.vue'),
    meta: {
        requiresAuth: true,
        section: 'bet'
    }
}

const betSeasonResults = {
    name: 'betSeasonResults',
    path: '/rangliste/:numberInChallenge?',
    props: true,
    component: () => import('../views/BetSeasonResultsView.vue'),
    meta: {
        requiresAuth: true,
        section: 'bet'
    }
}


const round = {
    name: 'round',
    path: '/spieltag/:leagueId?/:roundNumber?',
    alias: '/spieltag',
    props: true,
    component: () => import('../views/LeagueView.vue'),
    meta: {
        requiresAuth: true,
        section: 'round'
    }
}

const team = {
    name: 'team',
    path: '/team',
    component: () => import('../views/TeamView.vue'),
    meta: {
        requiresAuth: true,
        section: 'team'
    }
}

const tactics = {
    name: 'teamTactics',
    path: '/taktik',
    component: () => import('../views/TacticsView.vue'),
    meta: {
        requiresAuth: true,
        section: 'team'
    }
}

const transferMarket = {
    name: 'transfer',
    path: '/transfermarkt',
    component: () => import('../views/TransferMarketView.vue'),
    meta: {
        requiresAuth: true,
        section: 'transfer'
    }
}

const transferSquad = {
    name: 'kader',
    path: '/kader/:teamId',
    component: () => import('../views/TransferSquadView.vue'),
    meta: {
        requiresAuth: false,
        section: 'transfer'
    }
}

const emblemEditor = {
    name: 'emblemEditor',
    path: '/wappen-editor',
    component: () => import('../views/EmblemEditorView'),
    meta: {
        requiresAuth: true,
        section: 'team'
    }
}

const imprint = {
    name: 'imprint',
    path: '/impressum',
    component: () => import('../views/ImprintView'),
    meta: {
        requiresAuth: false,
        section: 'app'
    }
}

const shop = {
    name: 'shop',
    path: '/shop',
    component: () => import('../views/ShopView'),
    meta: {
        requiresAuth: false,
        section: 'shop'
    }
}

const admin = {
    name: 'administration',
    path: '/administration',
    component: () => import('@/admin/AdminView'),
    meta: {
        requiresAuth: true,
        section: 'admin'
    },
    children: [
        {
            name: 'administrationSpecialBets',
            path: 'sondertipps',
            component: () => import('../admin/specialbet/AdminSpecialBets'),
            meta: {
                displayName: "Sondertipps"
            }
        },
        {
            name: 'administrationTeams',
            path: 'mannschaften',
            component: () => import('../admin/team/AdminTeam'),
            meta: {
                displayName: "Teams"
            }
        }]
}

const challengeAndLeagueSelectorTest = {
    name: 'challengeAndLeagueSelectorTest',
    path: '/challenge-and-league-selector-test',
    component: () => import ('../views/ChallengeAndLeagueSelectorTestView'),
    meta: {
        requiresAuth: false
    }
}

const teamAndCoachSearchTest = {
    name: 'teamAndCoachSearchTest',
    path: '/team-and-coach-search-test',
    component: () => import ('../views/TeamAndCouachSearchTestView'),
    meta: {
        requiresAuth: false
    }
}

const componentTest = {
    name: 'ComponentTestView',
    path: '/test',
    component: () => import ('../views/ComponentTestView'),
    meta: {
        requiresAuth: false
    }
}

const testLayout = {
    path: '/test-layout',
    name: 'test-layout',
    component: () => import('../views/TestLayoutView'),
    meta: {
        requiresAuth: true,
        section: 'bet'
    }
}

const leagueRanking = {
    path: '/tabelle/:teamId',
    name: 'leagueRanking',
    props: true,
    component: () => import('../views/LeagueRanking.vue'),
    meta: {
        requiresAuth: false
    }
}

const routes = [
    challengeAndLeagueSelectorTest,
    teamAndCoachSearchTest,
    componentTest,
    home,
    login,
    newPassword,
    bet,
    betPeriodResults,
    betSeasonResults,
    specialBet,
    round,
    team,
    tactics,
    transferMarket,
    transferSquad,
    emblemEditor,
    shop,
    imprint,
    admin,
    testLayout,
    leagueRanking];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    let log = window.console.log;
    log(from.path + ' --> ' + to.path);
    if (!to.matched.some(route => route.meta.requiresAuth)) {
        next();
    } else {
        log('checking authentication...');
        if (store.getters.loggedIn) {
            log('...authenticated! route to ' + to.path);
            next();
        } else {
            log('...not authenticated! Trying to auto-login ...');
            store.dispatch('autoLoginAction')
                .then(() => {
                    if (store.getters.loggedIn) {
                        log('... success. continue routing');
                        if (to.path === '/') {
                            let betweenSeasons = store.getters.configuration.betweenSeasons;
                            next({
                                name: betweenSeasons ? 'transfer' : 'bet'
                            });
                        } else
                            next()
                    } else {
                        log('... no success.');
                        login.meta.next = to;
                        log('-->' + login.path + ' (next:' + login.meta.next.path + ')');
                        next(login)
                    }
                })
        }
    }
});

export default router
